export class ShowCongrats {
  static readonly type = '[congrats] Show congrats';
  constructor(readonly payload?: string) {}
}

export class ShowErrorMessage {
  static readonly type = '[congrats] Show error message';
  constructor(readonly payload?: string) {}
}
